<mat-card>
  <mat-card-content>
    <mat-card-title>Slider</mat-card-title>
    <mat-card-subtitle>mat-slider allows for the selection of a value from a range via mouse, touch, or keyboard,
      similar to <code
        class=""><a href="https://material.angular.io/pages/slider/overview">Official Component</a></code></mat-card-subtitle>

    <h4 class="m-b-0">Basic Slider</h4>
    <mat-slider>
      <input matSliderThumb>
    </mat-slider>    

    
  </mat-card-content>
</mat-card>
